import { WidgetsAddressCreateMain } from '@/widgets/address-create';

export const PagesAddressCreateMain = () => <WidgetsAddressCreateMain />;
